import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';
import {
    CreateCategoryAndSubcategory,
    CreateEquipment,
    CreateEquipmentImage,
    GetCategoryAndSubcategory,
    GetDeliveryById,
    GetEquipmentDetailsById,
    GetTrackByDeliveryId,
    UpdateEquipment,
} from './EquipmentApi';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const equipmentSlice = createSlice({
    name: 'equipment',
    initialState: {
        equipmentDetailsById: null,
        updateEquipment: null,
        categoryAndSubcategory: null,
        createCategoryAndSubcategory: null,
        createEquipment: null,
        createEquipmentImage: null,
        getDeliveryById: null,
        getTrackByDeliveryId:null,
    },
    reducers: {
        clearGetDeliveryById: (state) => {
            state.getDeliveryById = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(GetEquipmentDetailsById.fulfilled, (state, { payload }) => {
            state.equipmentDetailsById = ResponseApi(payload);
        });
        builder.addCase(UpdateEquipment.fulfilled, (state, { payload }) => {
            state.updateEquipment = ResponseApi(payload);
        });
        builder.addCase(GetCategoryAndSubcategory.fulfilled, (state, { payload }) => {
            state.categoryAndSubcategory = ResponseApi(payload);
        });
        builder.addCase(CreateCategoryAndSubcategory.fulfilled, (state, { payload }) => {
            state.createCategoryAndSubcategory = ResponseApi(payload);
        });
        builder.addCase(CreateEquipment.fulfilled, (state, { payload }) => {
            state.createEquipment = ResponseApi(payload);
        });
        builder.addCase(CreateEquipmentImage.fulfilled, (state, { payload }) => {
            state.createEquipmentImage = ResponseApi(payload);
        });
        builder.addCase(GetDeliveryById.fulfilled, (state, { payload }) => {
            state.getDeliveryById = payload;
        });
        builder.addCase(GetTrackByDeliveryId.fulfilled, (state, { payload }) => {
            state.getTrackByDeliveryId = payload;
        });
    },
});
export const { clearGetDeliveryById } = equipmentSlice.actions;
export default equipmentSlice.reducer;
